import { render } from "./CandidateProfile.vue?vue&type=template&id=4e5b7192&scoped=true"
import script from "./CandidateProfile.vue?vue&type=script&lang=js"
export * from "./CandidateProfile.vue?vue&type=script&lang=js"

import "./CandidateProfile.vue?vue&type=style&index=0&id=4e5b7192&scoped=true&lang=scss"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5b7192"]])

export default __exports__